import React from 'react';
import { Text, StyleSheet, View, ScrollView, Dimensions, Platform } from 'react-native';
import Theme from '../../theme';
import {
  ChevronRightIcon,
  MoistenMonitorStrapIcon,
  MonitorAttachmentIcon,
  StrapAdjustmentIcon,
  MonitorBatteryInsertIcon,
} from '../../ui/components/Icons';
import Orientation from 'react-native-orientation-locker';

export class MonitorActivationInstructions extends React.PureComponent<any, any>  {
  constructor(props: any) {
    super(props)

    this.state = {
      orientation: null,
    }
  }

  async componentDidMount() {
    const currentOrientation = await this.getDevicesOrientation();
    this.setState({ orientation: currentOrientation })
  }

  public getDevicesOrientation = (): Promise<string> => {
    return new Promise((resolve, _) => {
      Orientation.getOrientation((orientation: string) => {
        resolve(orientation);
      });
    });
  }

  instructions = () => {
    const instructions = [
      {
        instructionText: 'Insert a CR2032 battery. Use a coin to open the cover',
        icon: <MonitorBatteryInsertIcon width={200} height={200} />,
      },
      {
        instructionText: 'Moisten the electrode areas of the chest strap.',
        icon: <MoistenMonitorStrapIcon width={200} height={200} />,
      },
      {
        instructionText: "Attach the monitor to the chest strap ('L' faces your left hand).",
        icon: <MonitorAttachmentIcon width={200} height={200} />,
      },
      {
        instructionText: 'Adjust the length of the chest strap so that the monitor fist firmly against your skin.',
        icon: <StrapAdjustmentIcon width={200} height={200} />,
      },
      {
        instructionText: "Two 'beep-beep' sounds confirm a successful connection.",
      },
      {
        instructionText: 'The top of the screen should now show "Monitor Connected".',
      },
      {
        instructionText: 'If you are unable to connect, double check the serial number and battery.',
      },
    ];
    if (Platform.OS === 'android') {
      instructions.push({
        instructionText: `Also ensure that you have allowed access to your device's location. You can do this under Settings, Apps, Fitbeat, Permissions.`,
      });
      instructions.push({
        instructionText: `If you are still encountering problems connecting your belt ensure that your location services are enabled.`,
      });
    }
    return instructions;
  };

  public render() {
    const { orientation } = this.state;
    const containerStyle = orientation === 'PORTRAIT' ? { paddingHorizontal: 10 } : { paddingHorizontal: "25%" };
    return (
      <ScrollView style={{ flex: 1, marginBottom: 5 }} >
        <View style={[styles.container, containerStyle]}>
          <Text style={styles.label}>Instruction on how to activate the monitor</Text>
          <View style={styles.instructionsContainer}>
            {this.instructions().map((singleInstruction) => {
              return (
                <View style={styles.singleInstructionContainer}>
                  <View style={styles.instructionsTextContainer}>
                    <ChevronRightIcon width={15} height={15} />
                    <Text style={styles.instructionText}>{singleInstruction.instructionText}</Text>
                  </View>
                  <View style={styles.instructionsIconContainer}>
                    {singleInstruction.icon &&
                      (singleInstruction.icon)}
                  </View>
                </View>
              )
            })}
          </View>
        </View>
      </ScrollView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: Theme.GREY_LIGHT,
  },
  label: {
    color: Theme.BLACK,
    fontSize: 16,
    fontFamily: Theme.Custom700,
    paddingVertical: 10,
  },
  instructionsContainer: {
    flexDirection: 'column',
  },
  instructionsIconContainer: {
    alignSelf: 'center',
  },
  instructionsTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  singleInstructionContainer: {
    flexDirection: 'column',
    paddingVertical: 10,
  },
  loaderTextContainer: {
    flexDirection: 'column',
  },
  instructionText: {
    color: Theme.CHARCOAL,
    fontSize: 16,
    fontFamily: Theme.Custom500,
    paddingHorizontal: 10,
  }
});
